export default __webpack_public_path__ + "static/media/healthcare-hero.9e7a1668.png";